import { PUBLIC_URL } from "../../../config/react-env";

const isProductionMode = true;

/* localhost url */
export class HOST_URL {
  static url = isProductionMode
    ? PUBLIC_URL.url
    : "http://localhost:3005";

  static urlMobile = isProductionMode
    ? "https://api.mindamigo.com"
    : "http://localhost:5000";
}

export class STRIPE_KEY {
  static live_key =
    "pk_live_51OhuYiI6Ox2Kw1xbJ7kNFEQHJPc27Jrm6odk3amEQxPJ7Hofvxpsm88P7ZLYpPeEJa8U8Z0le3IE7qaeypKGs5KP006sfsapKV";
  static test_key =
    "pk_test_51OhuYiI6Ox2Kw1xbH575fxjPnggo5ieia7KI0Dwx3BeT8Cgx6mWLXc7L53Vmv5A71MHzod7eZQw1FGwJX5ewM7Sv00bYpxoJSB";
}

export class API_METHOD {
  static get = "GET";
  static post = "POST";
  static delete = "DELETE";
  static put = "PUT";
}

/* Base url of api */
export class BASE_URL {
  static url = "/organization";
  static adminUrl = "/admin";
  static employeeUrl = "/employee";
  static licenceUrl = "/license";
  static userGetUrl = "/users/get/";
  static moodJournalUrl = "/api/moodJournal";
  static subscriptionUrl = "/api/subscription";
  static coursesUrl = "/api/course";
  static thoughtRecordUrl = "/api/thoughtRecord";
  static optimismUrl = "/api/optimism";
  static abcdUrl = "/api/abcd";
  static journalUrl = "/api/journal";
  static meditationUrl = "/api/meditation";
  static breatheUrl = "/api/breath";
  static defusionUrl = "/api/defusion";
  static exploreUrl = "/api/explore";
  static moodJournalGetUrl = "/moodJournals/get";
  static moodJournalUpdateUrl = "/api/moodJournal/update";
  static wellbeingUrl = "/api/wellbeing";
  static recentUrl = "/api/recentActivity";
  static profileUrl = "/api/profile";
  static activationUrl = "/api/activation";
  static valuesUrl = "/api/values";
  static goalsUrl = "/api/goals";
  static referalUrl = "/api/user";
}

/* Request urls */
export class REQUEST_URL {
  static login = "/login";
  static register = "/register";
  static organizations = "/organizations";
  static verifyotp = "/verify-email";
  static forgotpassword = "/forgot-password";
  static resetpassword = "/reset-password";
  static details = "/details";
  static purchase = "/purchase-license";
  static paymentRequested = "/payment-requested";
  static updatePaymentDetails = "/update-payment-details";
  static giveDiscount = "/giveDiscount";
  static startDemo = "/start-demo";
  static registerEmployee = "/add-employee";
  static editEmployee = "/update-employee";
  static updateCompanyDetails = "/update-company-details";
  static updatePersonalDetails = "/update-profile-details";
  static followUp = "/followUp";
  static updateLicenseCount = "/update-license-count";
  static updateDemoLicense = "/updateDemoLicense";
  static organizationAccess = "/organizationAccess";
  static assignRepresentative = "/assign-representative";
  static resendOtp = "/resend-otp";
  static licenseBatches = "/license-batches";
  static logs = "/logs";
  static assignedAdmin = "/assigned-admin";
  static paymentLog = "/payments";
  static profile = "/profile";
  static allAdmins = "/all-admins";
  static updatePassword = "/update-password";
  static revokeEmployee = "/revoke-employee";
  static unRevokeEmployee = "/unrevoke-employee";
  static revokedEmployee = "/revoked-employees";
  static unRevokeMultipleEmployee = "/multiple-unrevoke";
  static allocateEmployees = "/allocate-employees";
  static revokedMultipleEmployee = "/multiple-delete";
  static addSingleEmployeeDemo = "/add-single-employee-demo";
  static addSingleEmployeeStandard = "/add-single-employee-Standard";
  static contact = "/contact";
  static user = "/user";
  static refreshToken = "/user/refreshToken";
  static resendEmail = "/resendEmail";
  static allusers = "/allusers";
  static clearInvoice = "/clearInvoice";

  /* Dashboard request url */
  static uploadEmployees = "/upload-employees-demo";
  static uploadEmployeesStandard = "/upload-employees-Standard";
  static employees = "/employees";
  static todayActivity = "/todayActivity";
  static updateActivity = "/updateActivity";

  /* Wellbeing request url */
  static questions = "/questions";

  /* Mood journal request url */
  static create = "/create";
  static getMoodDetails = "/getMoods";
  static setCompanion = "/setcompanion";
  static getCompanion = "/getcompanion";
  static updateCompanion = "/updatecompanion";
  static moodList = "/moodlist";
  static calendar = "/calendar";
  static averageMood = "/averagemood";
  static moodCount = "/statsmoodcount";
  static payment = "/payment";
  static stripeapikey = "/stripeapikey";
  static frequentlyFelt = "/frequentlyfelt";

  /* Courses request urls */
  static courseColors = "/setCampanion";
  static courseSessions = "/sessions";
  static completedSessions = "/completedSessions";
  static courseSubtitle = "/courseSubtitle";

  /* ThoughtRecord request urls */
  static allThoughtEntries = "/entries";

  /* optimism request urls */
  static allOptimismEntries = "/entries";

  /* Abcd request urls */
  static allAbcdEntries = "/entries";

  /* favourites request url */
  static techniques = "/techniques";
  static meditation = "/meditation";
  static techniqueMeditation = "/techniqueMeditation";

  /* Profile request url */
  static notificationSetting = "/notificationSetting";
  static editProfile = "/editProfile";
  static updateUserDetails = "/updateUserDetails";
  static subscriptionProfile = "/subscription";

  /* Journal request url */
  static color = "/color";

  /* Activation request url */
  static getEnjoyment = "/Enjoyment";
  // static getEnjoyment = "/Accomplishment"

  /* Goal request url */
  static allGoalEntries = "/allentries";

  /* Defusion request url */
  static story = "/story";
  static mind = "/mind";
}

// snackbar status
export class Severity {
  static success = "success";
  static info = "info";
  static warning = "warning";
  static error = "error";
}

/* Console enable/disable */
export class CONSOLE_MODE {
  static mode = isProductionMode ? 'production' : "development";
}
